import { ReactNode } from 'react';

import styles from './modal.module.css';

export type ModalCardProps = {
  title: string;
  children: ReactNode;
};

const ModalCard: React.FC<ModalCardProps> = ({ title, children }) => (
  <div id="modal" className={`bg-primary ${styles.wrapper}`}>
    <p className="font-24 mb-24 font-medium">{title}</p>
    <div className="flex-col">{children}</div>
  </div>
);

export default ModalCard;
